// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Lu7fqIrx8qmIding-0Zkf","cancelBtn":"_2NiS4hEW0ymD2Rj0qMxHpC","icon":"_27XRsepCddHauox71RN71z","saveBtn":"_3OuPqQkYPjgSdZCqfT_Lfc"};